{
  "id": "campaign-111",
  "name": "Stately Terrace",
  "seed": "campaign:111",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".......ACCA.......",
    "..B.....CC.....B..",
    "........CC........",
    "........CC........",
    "wwwwwwww++wwwwwwww",
    "........CC........",
    "...q.t..CC..t.q...",
    ".....,.CCCC.......",
    "CCCCCCCCOOCCCCCCCC",
    ".....,.CCCC.......",
    "*....t..CC..t....*",
    "*.T.T..%CC%..T.T.*",
    "*.....%%CC%%.....*",
    "...q...%CC%...q...",
    "........CC........",
    "..............x...",
    ".................S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 11,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 15
    },
    {
      "kind": "squirrel",
      "x": 15,
      "y": 10
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 4,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 16,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 16,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 10
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 111,
  "biome": "estate",
  "par": {
    "reel": 9076,
    "push": 7866,
    "selfPropelled": 7476,
    "tractor": 6310,
    "zeroTurn": 5229,
    "fairway": 3532
  },
  "goldTime": {
    "reel": 9076,
    "push": 7866,
    "selfPropelled": 7428,
    "tractor": 5890,
    "zeroTurn": 5161,
    "fairway": 3532
  },
  "routeTries": {
    "par": {
      "reel": 13,
      "push": 12,
      "selfPropelled": 14,
      "tractor": 7,
      "zeroTurn": 0,
      "fairway": 23
    },
    "gold": {
      "reel": 13,
      "push": 12,
      "selfPropelled": 41,
      "tractor": 49,
      "zeroTurn": 25,
      "fairway": 23
    }
  }
}
